import { Tag } from "../../types/Tag";

import React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";

const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
}));

interface TagDisplayProps {
    tags: Tag[];
}

const TagDisplay: React.FC<TagDisplayProps> = ({ tags }) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "left",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
            }}
            component="ul"
        >
            {tags.map((tag: Tag) => {
                return (
                    <ListItem key={tag.id}>
                        <Chip label={tag.label} clickable={false} color="primary" />
                    </ListItem>
                );
            })}
        </Box>
    );
};

export default TagDisplay;
